import React, { FC } from 'react'
import { ScrollDimModal } from '~/app/components'
import { useRouter } from 'next/router'
import ReceiptModalContent from './ReceiptModalContent'
import { OrderReceipt } from '~/app/components/order-list/hooks/useReceiptInfo'

/**
 * ReceiptModal component
 * author: soojin.oh
 */

// type definitions
type Props = {
  isOpened: boolean
  orderReceipts: OrderReceipt[]
}

// styled components

// ReceiptModal component
const TARGET_ID = 'RECEIPT_MODAL'
const ReceiptModal: FC<Props> = function ({ isOpened, orderReceipts }) {
  const { back } = useRouter()

  return (
    <ScrollDimModal isOpened={isOpened} targetId={TARGET_ID}>
      <ReceiptModalContent orderReceipts={orderReceipts} onClickBack={back} />
    </ScrollDimModal>
  )
}

export default ReceiptModal
